export default __webpack_public_path__ + "static/media/iconLogo64.ce0c67ad.svg";